import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumLarge)};
  padding: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
`;

export const StyledInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumLarge)};
  border: ${({ theme }) => utils.rem(theme.Border.Size.Small)} solid
    ${({ theme }) => theme.Color.Neutrals.Border};
  padding: ${({ theme }) =>
    ` ${utils.rem(theme.Spacing.Size.XLarge)} ${utils.rem(theme.Spacing.Size.MediumSmall)}`};
  border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Large)};
  margin-bottom: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
  width: 100%;
`;

export const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
  text-align: center;
`;

export const StyledDescriptionWrapper = styled.div`
  text-align: center;
`;

export const StyledAlertWrapper = styled.div`
  width: 100%;
`;

export const StyledAlertIconWrapper = styled.div`
  margin-right: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
`;

export const StyledAlertButtonWrapper = styled.div`
  margin-left: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
`;

export const StyledImportStepTitleWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledTokenContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
  padding: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
  border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Large)};
  background-color: ${({ theme }) => theme.Color.Neutrals.Light};
  width: 100%;
`;

export const StyledTokenInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
`;
